<template>
  <div class="container">
    <div class="menu">
      <div class="submenu">
        <h2>{{ this.count }} Comment<span v-show="this.count > 1">s</span></h2>
      </div>
    </div>
    <div class="textarea-comments">
      <textarea
        v-model="comment"
        placeholder="Write your comment here"
        name=""
        id=""
        cols="20"
        rows="2"
      ></textarea>

      <p class="comment-message" v-show="message">
        You Must Log In To Comments. Thanks!
      </p>
      <button class="comment-btn" @click="saveComment">Comment</button>
    </div>

    <div v-for="item in comments" class="comments-area" :key="item.id">
      <span class="icon-area"
        ><font-awesome-icon class="user-icon" id="user-icon" icon="user"
      /></span>
      <span class="user-area"
        ><span class="text-black"> {{ item.user }} </span>
        {{ item.date | date_single_updates }}</span
      >
      <span class="comment-area">{{ item.comment }}</span>
      <span class="likes-area" :class="{ active: item.liked }"
        ><font-awesome-icon
          class="user--btn-icon"
          id="user--btn-icon"
          icon="thumbs-up"
          @click="likeComment(item)"
        />
        {{ item.likesCount }}</span
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["user", "alert"]),
  name: "Comments",
  data: () => ({
    comments: [],
    count: "",
    params: {
      articleId: "",
      page: "",
      sortBy: "",
    },
    paramsC: {
      articleId: "",
      comment: "",
    },
    paramsL: {
      commentId: "",
      like: true,
    },
    comment: "",
    message: false,
    article: "",
  }),
  created() {
    this.article = this.$route.params.id;
    this.getComments();
  },
  watch: {
    comment() {
      this.comment.length && !this.user.username
        ? (this.message = true)
        : (this.message = false);
    },
  },

  methods: {
    getComments() {
      this.params.articleId = this.article;
      this.$Parse.Cloud.run("getArticleComments", this.params)
        .then((result) => {
          // this.series = res.items;
          this.comments = result.comments;
          this.count = result.totalItems;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveComment() {
      if (!this.user.username || !this.comment.length) return;
      this.paramsC.articleId = this.article;

      if (
        document.cookie.replace(
          /(?:(?:^|.*;\s*)comment=\s*([^;]*).*$)|^.*$/,
          "$1"
        ) == this.paramsC.articleId
      ) {
        this.alert.color = "#EF3D58";
        this.alert.message =
          "Please, wait ten minutes to send your new comment";
        this.$store.commit("editAlert", this.alert);
        return;
      }

      document.cookie = `comment=${this.paramsC.articleId};max-age=600`;
      this.paramsC.comment = this.comment;
      this.$Parse.Cloud.run("saveArticleComment", this.paramsC)
        .then((result) => {
          result.liked = false;
          result.likesCount = 0;
          this.comments.unshift(result);
          this.comment = "";
          this.count++;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    likeComment(item) {
      this.paramsL.commentId = item.id;
      this.paramsL.like = !item.liked;
      this.$Parse.Cloud.run("saveArticleCommentLike", this.paramsL)
        .then(() => {
          // this.series = res.items;
          const index = this.comments.findIndex(
            (element) => element.id == item.id
          );
          this.comments[index].liked = !this.comments[index].liked;
          if (Number.isNaN(this.comments[index].likesCount))
            this.comments[index].likesCount = 0;
          if (this.comments[index].liked == true)
            this.comments[index].likesCount++;
          else this.comments[index].likesCount--;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.menu {
  display: grid;
  padding-top: 25px;
  padding-left: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #738092;
}
.submenu {
  display: grid;
  grid-template-columns: 1fr;
  justify-content: start;
  column-gap: 35px;
}

.submenu > h2 {
  font-weight: 300;
  margin: 0;
}
.textarea-comments {
  margin: 40px 5% 30px 5%;
}
.textarea-comments > textarea {
  width: 100%;
  border-radius: 15px;
  border: 0.5px solid #ffffff;
  background: none;
  color: white;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-size: 16px;
  padding: 20px;
  outline: none;
}
.textarea-comments > textarea:focus {
  border: 0.5px solid #94c659;
  box-shadow: 0 2px 4px -1px rgba(37, 152, 83, 0.2),
    0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.comment-btn {
  margin: 1%;
  font-weight: 600;
  background-color: #94c659;
  width: 110px;
  line-height: 30px;
  border-radius: 10px;
  border: 0px;
  color: rgba(246, 246, 246, 0.778);
  cursor: pointer;
}
.comment-btn:hover {
  color: #efefef;
}
.comment-btn:active {
  width: 109px;
  line-height: 29px;
}

.comment-message {
  margin-top: 0px;
  color: #94c659;
  margin-left: 1%;
}
.comments-area {
  width: 90%;
  margin: 20px 5%;
  display: grid;
  grid-template-columns: 70px auto;
  grid-template-areas:
    "icon-area user-area"
    "icon-area comment-area"
    ". likes-area";
  border-bottom: 0.5px solid #425a7a;
  padding-bottom: 5px;
}

.icon-area {
  grid-area: icon-area;
  background-color: #4885d1;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  margin: 3px 10px;
}
.active {
  color: #94c659;
}
.user-icon {
  font-size: 30px;
  margin-top: 8px;
  margin-left: 12px;
}
.user--btn-icon {
  cursor: pointer;
  margin-right: 10px;
}
.user--btn-icon:hover {
  color: #d1d1d1;
}
.user-area {
  grid-area: user-area;
  font-weight: 300;
  margin: 5px;
}
.user-area > span {
  margin-right: 10px;
}
.text-black {
  font-weight: 800;
}
.comment-area {
  grid-area: comment-area;
  margin: 5px;
}
.likes-area {
  grid-area: likes-area;
  margin: 10px 5px;
}

@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
}

@media (max-width: 600px) {
  .menu {
    margin: 0 5px;
  }

  .textarea-comments {
    margin: 5%;
    width: 90%;
  }
  .textarea-comments > textarea {
    width: 90%;
    padding: 10px;
    font-size: 15px;
    height: 150px;
  }
}
</style>
